export default "__VITE_ASSET__5f5ec1be__"